<template>
  <transition-group name='fade'>
    <!-- 蒙版 -->
    <div  @click="defaultMask" class="mask" key="1" v-if="show" @touchmove.prevent></div>

    <div class="pop" v-show="show" key="2">
      <el-card>
        <el-form @keydown.enter.native="onSubmit" class="login-box" label-width="25%" ref="login">
          <div class="pwd_title">修改密码</div>
          <el-input prefix-icon="el-icon-lock" placeholder= "当前密码" type="password" v-model="currentPassword" class="pwd_content"></el-input>
          <el-input prefix-icon="el-icon-lock" placeholder= 新密码 type="password" v-model="newPassword" class="pwd_content"></el-input>
          <el-input prefix-icon="el-icon-lock" placeholder="再次输入新密码" type="password" v-model="checkNewPassword" class="pwd_content"></el-input>
          <el-button type="primary" @click="onSubmit()" class="pwd_btn">确定</el-button>
          <el-button type="warning"  @click="cancel()" class="pwd_btn">取消</el-button>
        </el-form>
      </el-card>
    </div>
  </transition-group>
</template>

<script>
  import {changePassword} from "../../until/api/login";

  export default {
    name: 'updatePwd',
    data() {
      return {
        show: false,
        currentPassword: '',
        newPassword: '',
        checkNewPassword: '',
      }
    },

    created() {},

    methods: {
      /**
       * 修改密码
       */
      onSubmit() {
        if(this.currentPassword != '' && this.newPassword != '' && this.checkNewPassword != '') {
          if(this.newPassword == this.checkNewPassword ) {
            let param = {"currentPassword":this.currentPassword, "newPassword": this.newPassword};
            changePassword(param).then(response=>{
              this.$message({
                showClose: true,
                type:'success',
                message: '更新密码成功'
              })
              let loginParam = {"username":this.$commonFun.unCompileStr(localStorage.getItem('email')), "password": this.newPassword};
              localStorage.setItem('login', this.$commonFun.compileStr(JSON.stringify(loginParam)));
              this.show = false;
            }).catch(error=>{
              console.log("error",error);
              this.$message({
                showClose: true,
                type:'warning',
                message: '更新密码失败请重新输入'
              })
            })
          } else {
            this.$message({
              showClose: true,
              type:'warning',
              message: '前后两次新密码不一致，请重新输入'
            })
          }

        } else {
          this.$message({
            showClose: true,
            type:'warning',
            message: '密码为空，请重新输入'
          })
        }

      },

      /**
       * 取消修改密码
       */
      cancel() {
        this.show = false;
        this.currentPassword = '';
        this.newPassword = '';
        this.checkNewPassword = '';
      },

      /**
       * 取消修改密码
       */
      defaultMask() {
        this.show = false;
        this.currentPassword = '';
        this.newPassword = '';
        this.checkNewPassword = '';
      }
    }
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }
  // 全局弹窗
  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
  }

  .pop {
    height: 32%;
    width: 20%;
    background: #2B5DA0;
    border-radius: 8px;
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: -10%;
    z-index: 20;
    text-align: center;

    .el-card {
      background-color:transparent;
      border: none;
    }

    /deep/ .el-input__inner {
      background-color: transparent;
      border: 1px solid #4cc9d5;
      color: #ffffff;
    }

    /deep/ .el-input__icon{
      font-size:24px;
      margin-top: 10px;
    }

    .pwd_title {
      font-size: 24px;
      text-align:center;
      color: #ffffff
    }

    .pwd_content {
      padding-top: 5%
    }

    .pwd_btn {
      margin-top: 5%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/popup/updatePwd.vue